/**
 * BranchContextBadge (Jun-2026, User-Wunsch) — zeigt modulübergreifend den aktiven
 * Filial-Kontext (``X-Org-Branch``) an, damit ein Hauptsitz nie versehentlich im
 * falschen Filial-Bestand arbeitet/bucht. Spiegelt den In-Memory-Kontext
 * (`getApiOrgBranch`) — bleibt also exakt mit den geladenen Daten konsistent.
 */
import { useEffect, useState } from "react";
import { Building2, X } from "lucide-react";
import api, { getApiOrgBranch, setApiOrgBranch } from "../lib/api";

export default function BranchContextBadge({ user }) {
    const isHauptsitz = user && user !== false && user.role === "b2b" && user.branch_role === "hauptsitz";
    const [branchId, setBranchId] = useState(() => getApiOrgBranch());
    const [locations, setLocations] = useState([]);

    useEffect(() => {
        const handler = (e) => setBranchId(e.detail?.id || null);
        window.addEventListener("tw-branch-changed", handler);
        return () => window.removeEventListener("tw-branch-changed", handler);
    }, []);

    useEffect(() => {
        if (!isHauptsitz) return;
        api.get("/org/locations").then((r) => setLocations(r.data?.locations || [])).catch(() => {});
    }, [isHauptsitz]);

    if (!isHauptsitz || !branchId) return null;
    const selfId = locations.find((l) => l.is_self)?.dealer_id;
    if (branchId === selfId) return null;

    let label;
    if (branchId === "__all__") label = "Alle Standorte";
    else {
        const loc = locations.find((l) => l.dealer_id === branchId);
        label = loc ? (loc.site_code || loc.company_name) : "Filiale";
    }

    const reset = () => {
        setApiOrgBranch(null);
        sessionStorage.removeItem("tw_scope_branch");
        window.location.reload(); // sauberer Refetch aller Module im eigenen Kontext
    };

    return (
        <div data-testid="branch-context-badge"
            className="inline-flex items-center gap-1.5 h-9 px-2.5 rounded-sm bg-[#111827] text-[#FFCC00] text-xs font-bold uppercase tracking-wider"
            title="Aktiver Filial-Kontext — alle Daten/Buchungen betreffen diesen Standort">
            <Building2 className="w-3.5 h-3.5" /> Standort: {label}
            <button type="button" onClick={reset} title="Auf eigenen Standort zurücksetzen"
                data-testid="branch-context-reset" className="ml-1 hover:text-white">
                <X className="w-3.5 h-3.5" />
            </button>
        </div>
    );
}
